(function () {
  const root = document.querySelector('[data-inset-bio-pdp]');
  if (!root) return;

  const form = root.querySelector('[data-product-form]');
  const variantInput = form && form.querySelector('[data-product-variant]');
  if (!form || !variantInput) return;

  const jsonEl = form.querySelector('[data-product-json]');
  let variants = [];
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch (error) {
    return;
  }

  const fuelBtns = root.querySelectorAll('[data-inset-fuel]');
  const gallery = root.querySelector('[data-inset-gallery]');
  const stage = gallery && gallery.querySelector('[data-inset-stage]');
  const thumbs = gallery ? gallery.querySelectorAll('[data-inset-thumb]') : [];

  function currentFuel() {
    return root.getAttribute('data-selected-fuel') || 'coals';
  }

  function findVariant(fuel) {
    return variants.find((entry) => entry.effect === fuel) || variants[0];
  }

  function setPressed(value) {
    fuelBtns.forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-inset-fuel') === value ? 'true' : 'false');
    });
  }

  function thumbOrder(fuel) {
    return fuel === 'logs'
      ? [
          'lifestyle-logs',
          'model',
          'receive',
          'product-logs',
          'logs-only',
          'lifestyle-coals',
          'product-coals',
          'coals-only',
          'technical',
        ]
      : [
          'lifestyle-coals',
          'model',
          'receive',
          'product-coals',
          'coals-only',
          'lifestyle-logs',
          'product-logs',
          'logs-only',
          'technical',
        ];
  }

  function orderThumbs(fuel) {
    const list = gallery && gallery.querySelector('.inset-gas-gallery__thumbs');
    if (!list) return;
    thumbOrder(fuel).forEach((role) => {
      const btn = list.querySelector('[data-inset-thumb][data-role="' + role + '"]');
      const item = btn && btn.closest('li');
      if (item) list.appendChild(item);
    });
  }

  function preferredMedia(fuel) {
    const role = fuel === 'logs' ? 'lifestyle-logs' : 'lifestyle-coals';
    return (gallery && gallery.querySelector('[data-inset-thumb][data-role="' + role + '"]')) || thumbs[0] || null;
  }

  function showThumb(thumb) {
    if (!thumb || !stage) return;
    const src = thumb.getAttribute('data-full-src');
    const alt = thumb.getAttribute('data-full-alt') || '';
    const img = stage.querySelector('img');
    if (img && src) {
      img.src = src;
      img.removeAttribute('srcset');
      img.alt = alt;
      stage.setAttribute('data-role', thumb.getAttribute('data-role') || '');
    }
    thumbs.forEach((other) => other.classList.toggle('is-active', other === thumb));
  }

  function formatChoice(fuel, variant) {
    const label = fuel === 'logs' ? 'Coals & Logs' : 'Coals';
    const price = variant && variant.price_label ? variant.price_label : '';
    return price ? 'Your choice: ' + label + ' — ' + price : 'Your choice: ' + label;
  }

  function syncChoice(fuel, variant) {
    const choice = root.querySelector('[data-bio-choice]');
    if (choice) choice.textContent = formatChoice(fuel, variant);
  }

  function syncIncludes(fuel) {
    const isLogs = fuel === 'logs';
    root.querySelectorAll('[data-bio-include-coals]').forEach((el) => {
      el.hidden = isLogs;
    });
    root.querySelectorAll('[data-bio-include-logs]').forEach((el) => {
      el.hidden = !isLogs;
    });
  }

  function apply(updateGallery) {
    const fuel = currentFuel();
    setPressed(fuel);
    syncIncludes(fuel);
    const variant = findVariant(fuel);
    syncChoice(fuel, variant);
    if (variant) {
      variantInput.value = String(variant.id);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (updateGallery) {
      orderThumbs(fuel);
      showThumb(preferredMedia(fuel));
    }
  }

  fuelBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      root.setAttribute('data-selected-fuel', btn.getAttribute('data-inset-fuel'));
      apply(true);
    });
  });
  root.querySelectorAll('[data-choose-fuel]').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.setAttribute('data-selected-fuel', btn.getAttribute('data-choose-fuel'));
      apply(true);
      root.querySelector('.inset-gas-steps')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', (event) => {
      event.preventDefault();
      showThumb(thumb);
    });
  });

  apply(true);
})();
